import { FilterType, getDistinctItems, getNumberOfFiltersApplied, logger, ShowtimeFilterKey } from '@vista/omnichannel-components-domain';
import { ShowtimePickerMessageType as MessageType } from '../subcomponents/message';
/**
 * Returns the unique list of film IDs for a given list of showtimes.
 */
export const getFilmIdsForShowtimes = (showtimes) => {
    return getDistinctItems(showtimes.map(s => s.filmId));
};
export const handleApiError = (err) => {
    logger.error('Showtime picker API error: ', err);
    // Show error toast
    return MessageType.FailedToLoadData;
};
export const nonFixedFiltersApplied = (filterConfig) => {
    if (!filterConfig)
        return false;
    return (getNumberOfFiltersApplied({
        id: filterConfig.filterId,
        type: FilterType.Showtime,
        keys: Object.values(ShowtimeFilterKey)
    }) > 0);
};
